import { Cartridge, Nes } from '@/Emulator';
import { IComponent }     from '@/Interface/IComponent';
import { Component, h, Host, JSX, Prop, State } from '@stencil/core';

@Component({
    tag:      'nes-cartridge-debugger',
    styleUrl: './nes-cartridge-debugger.scss',
    shadow:   true,
})
export class NesCartridgeDebugger implements IComponent
{
    @Prop() public nes!: Nes;

    @State() public cartridge: Nullable<Cartridge> = null;

    /**
     * @inheritDoc
     */
    public componentWillLoad(): void
    {
        this.cartridge = this.nes.cartridge;

        this.nes.on('cartridge-will-load', c => this.cartridge = c);
        this.nes.on('cartridge-did-load', c => this.cartridge = c);
    }

    public render(): JSX.Element
    {
        if (! this.cartridge) {
            return <Host/>;
        }

        return (
            <table class="data-table">
                <tbody>
                <tr>
                    <td>Cartridge ID</td>
                    <td>{this.cartridge.id}</td>
                </tr>
                <tr>
                    <td>Mapper ID</td>
                    <td>{this.cartridge.mapperId}</td>
                </tr>
                <tr>
                    <td>Mirror Mode</td>
                    <td>{this.cartridge.mirrorMode}</td>
                </tr>
                <tr>
                    <td>PRG RAM Size</td>
                    <td>{this.cartridge.prgRam.length}</td>
                </tr>
                <tr>
                    <td>PRG ROM Size</td>
                    <td>{this.cartridge.prgRom.length}</td>
                </tr>
                <tr>
                    <td>CHR ROM Size</td>
                    <td>{this.cartridge.chrData.length}</td>
                </tr>
                <tr>
                    <td>Has Battery</td>
                    <td>{this.cartridge.hasBattery ? '✓' : '×'}</td>
                </tr>
                <tr>
                    <td>Has Character RAM</td>
                    <td>{this.cartridge.hasChrRam ? '✓' : '×'}</td>
                </tr>
                <tr>
                    <td>Video System</td>
                    <td>{this.cartridge.videoSystem.type}</td>
                </tr>
                <tr>
                    <td/><td>{this.cartridge.videoSystem.cpuCyclesPerSecond.toLocaleString()} CPU cycles</td>
                </tr>
                <tr>
                    <td/><td>{this.cartridge.videoSystem.ppuSpeedRatio.toLocaleString()} PPU ratio</td>
                </tr>
                </tbody>
            </table>
        );
    }
}
